// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"10b1a817","545":"b74df548","787":"cda612ba"}[chunkId] + ".chunk.js";
};